import { foldersTree, foldersTreeDD } from './dataroom-translation-tree';

const localTextMap = {
  VisibleToAll: {
    en: 'Files for all Users',
    nb: 'Felles filer for alle brukere',
  },
};

assignTreeTranslations(foldersTreeDD);
assignTreeTranslations(foldersTree);

function assignTreeTranslations(arr) {
  for (const item of arr) {
    localTextMap[item.key] = {
      nb: item.nb,
      en: item.en,
      sv: item.sv,
    };

    if (item.children) {
      assignTreeTranslations(item.children);
    }
  }
}

const textMappingsFilebrowser = localTextMap;
export { textMappingsFilebrowser };
